import { orderBy } from 'lodash';
import React from 'react';

import {
    AbilityLookup,
    Action,
    CharClass,
    ClassFeature,
    ClassUtils,
    DataOriginRefData,
    Feat,
    InfusionChoice,
    RuleData,
    SnippetData,
    Spell,
} from '@dndbeyond/character-rules-engine/es';

import ClassDetail from '../ClassDetail';

interface Props {
    classes: Array<CharClass>;
    onActionUseSet: (action: Action, uses: number) => void;
    onActionClick: (action: Action) => void;
    onSpellClick: (spell: Spell) => void;
    onSpellUseSet: (spell: Spell, uses: number) => void;
    onFeatureClick: (feature: ClassFeature, charClass: CharClass) => void;
    onInfusionChoiceClick: (infusionChoice: InfusionChoice) => void;
    feats: Array<Feat>;
    snippetData: SnippetData;
    ruleData: RuleData;
    abilityLookup: AbilityLookup;
    dataOriginRefData: DataOriginRefData;
    isReadonly: boolean;
    proficiencyBonus: number;
    theme: any;
}
export default class ClassesDetail extends React.PureComponent<Props> {
    render() {
        const { classes, ...restProps } = this.props;

        let orderedClasses = orderBy(classes, (charClass) => ClassUtils.getName(charClass));

        return (
            <div className="ct-classes-detail">
                {orderedClasses.map((charClass) => (
                    <ClassDetail {...restProps} key={ClassUtils.getId(charClass)} charClass={charClass} />
                ))}
            </div>
        );
    }
}
